import React from 'react';
import { AppBar, Toolbar, Typography, Box, makeStyles, Button, Tooltip, IconButton } from '@material-ui/core';
import { ExitToApp, Menu as MenuIcon, MenuOpen as MenuOpenIcon } from '@material-ui/icons';
import { useApiKey } from '../context/ApiKeyContext';

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: '#fff',
    color: '#333',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    zIndex: theme.zIndex.drawer + 1,
  },
  logoText: {
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center'
  },
  red: {
    color: theme.palette.primary.main,
  },
  gray: {
    color: '#7e7e7e',
    marginLeft: theme.spacing(1),
    fontSize: '0.6rem',
    verticalAlign: 'bottom'
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '0px'
  },
  logoutButton: {
    marginLeft: theme.spacing(2),
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  menuArea: {
    display: 'flex',
    alignItems: 'center',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  }
}));

const Header = ({ isAuthenticated, setIsAuthenticated, onMenuClick, menuOpen }) => {
  const classes = useStyles();
  const { clearApiKey } = useApiKey();

  const handleLogout = () => {
    clearApiKey();
    setIsAuthenticated(false);
  };

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <div className={classes.menuArea}>
          {isAuthenticated && (
            <IconButton
              color="inherit"
              aria-label={menuOpen ? "fechar menu" : "abrir menu"}
              edge="start"
              onClick={onMenuClick}
              className={classes.menuButton}
            >
              {menuOpen ? <MenuOpenIcon /> : <MenuIcon />}
            </IconButton>
          )}
          <Typography variant="h6" className={classes.logoText}>
            <Box display="flex" alignItems="center">
              <span>[</span>
              <span className={classes.red}>eLaw &nbsp;</span>
              <span> Gen</span>
              <span className={classes.red}>AI</span>
              <span>]</span>
              <span className={classes.gray}>v1.0.0</span>
            </Box>
          </Typography>
        </div>
        
        {isAuthenticated && (
          <Box className={classes.userInfo}>
            <Typography variant="body2" color="textSecondary">
              Usuário autenticado
            </Typography>
            <Tooltip title="Sair do sistema">
              <Button
                color="secondary"
                className={classes.logoutButton}
                startIcon={<ExitToApp />}
                onClick={handleLogout}
                size="small"
              >
                Sair
              </Button>
            </Tooltip>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header; 